import React from 'react';

const isEmpty = itemsReceivedNumber => {
  // Type the code for the body of your function or hook here.
  // Functions can be triggered via Button/Touchable actions.
  // Hooks are run per ReactJS rules.

  /* String line breaks are accomplished with backticks ( example: `line one
line two` ) and will not work with special characters inside of quotes ( example: "line one line two" ) */

  var boolean;

  if (itemsReceivedNumber == 0) {
    boolean = true;
  } else {
    boolean = false;
  }

  return boolean;
};

export default isEmpty;
